/* Feston — theme scripts. No dependencies. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Menu drawer ---------- */

  var drawer = document.getElementById('MenuDrawer');
  var scrim = document.getElementById('DrawerScrim');
  var burger = document.querySelector('[data-menu-toggle]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    var first = drawer.querySelector('a, button');
    if (first) first.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) {
      drawer && drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }

    var parent = e.target.closest('[data-submenu-toggle]');
    if (parent) {
      var panel = parent.nextElementSibling;
      var open = parent.getAttribute('aria-expanded') === 'true';
      parent.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.classList.toggle('is-open', !open);
      return;
    }

    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var main = document.getElementById('ProductMainImage');
      if (main) {
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = thumb.dataset.full;
          main.alt = thumb.alt;
          main.style.opacity = '1';
        }, reduced ? 0 : 140);
      }
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();

    // Keep tab focus inside the open drawer
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var items = drawer.querySelectorAll('a, button');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 950 && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* ---------- Collection sorting ---------- */

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* ---------- Scroll reveal ---------- */

  var revealables = document.querySelectorAll('[data-reveal]');
  if (revealables.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      revealables.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      revealables.forEach(function (el, i) {
        // Stagger siblings inside the same grid
        var parent = el.parentElement;
        if (parent && parent.classList.contains('grid')) {
          var index = Array.prototype.indexOf.call(parent.children, el);
          el.style.setProperty('--reveal-delay', Math.min(index, 7) * 60 + 'ms');
        }
        observer.observe(el);
      });
    }
  }

  /* ---------- Header hide on scroll down, show on scroll up ---------- */

  var header = document.querySelector('.header');
  if (header) {
    var lastY = window.scrollY;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        header.classList.toggle('is-stuck', y > 8);
        if (!document.body.classList.contains('is-locked')) {
          if (y > lastY && y > 260) header.classList.add('is-hidden');
          else header.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Sticky buy bar on phones ---------- */

  var buyBar = document.getElementById('BuyBar');
  var mainAtc = document.getElementById('MainAddToCart');
  var waFloat = document.querySelector('.wa-float');

  if (buyBar && mainAtc && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        buyBar.classList.toggle('is-visible', show);
        if (waFloat) waFloat.classList.toggle('is-lifted', show);
      });
    }, { threshold: 0 });
    barObserver.observe(mainAtc);

    buyBar.addEventListener('click', function (e) {
      if (e.target.closest('[data-buy-now]')) {
        mainAtc.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      }
    });
  }

  /* ---------- Cart count bump after adding ---------- */

  var count = document.querySelector('.cart-count');
  if (count && sessionStorage.getItem('feston-cart') !== count.textContent) {
    if (sessionStorage.getItem('feston-cart') !== null) {
      count.classList.add('is-bumped');
      setTimeout(function () { count.classList.remove('is-bumped'); }, 500);
    }
    sessionStorage.setItem('feston-cart', count.textContent);
  }
})();
